import apiPaths from '../api-paths';

export default {
  index(query = '') {
    return axios.get(`${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices${ query }`);
  },

  show({ id, query = '' }) {
    return axios.get(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/${ id }${ query }`,
    );
  },

  automaticBookPreflight({ id }) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/${ id }/automatic-book-preflight`);
  },

  acceptInvoiceItems(purchaseId, data) {
    return axios.post(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/${ purchaseId }/accept-invoice-items`,
      data,
    );
  },

  setApprovalStatus(purchasesIds, status) {
    return axios.post(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/bulk-set-status`,
      {
        invoice_ids: purchasesIds,
        approval_status: status,
      },
    );
  },

  importPurchases() {
    return axios.post(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/import`,
    );
  },

  getAuditLog(purchaseId, query = '') {
    return axios.get(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/${ purchaseId }/audit-log${ query }`,
    );
  },

  getPdfUrl(purchaseId) {
    return axios.get(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/${ purchaseId }/pdf`,
    );
  },

  getSourceXML(purchaseId) {
    return axios.get(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/${ purchaseId }/source-xml`,
    );
  },

  archive(purchaseId) {
    return axios.post(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/${ purchaseId }/archive`,
    );
  },

  batchArchive(invoiceIds) {
    return axios.post(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/batch-archive`,
      {
        invoice_ids: invoiceIds,
      },
    );
  },

  isBooked({ id }) {
    return axios.get(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/${ id }/is-booked`,
    );
  },

  getNextAvailableForBooking({ direction, excludedInvoiceIds = [] } = {}) {
    return axios.get(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/next-available-for-booking`,
      {
        params: {
          direction,
          excluded_invoice_ids: excludedInvoiceIds,
        },
      },
    );
  },

  getItemCommentsCounts(id) {
    return axios.get(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/${ id }/item-comments-counts`,
    );
  },

  // Wiersze okna księgowania zbiorczego — jedno wywołanie na całe okno, nie per wiersz.
  bookingBatchWindow({ ids }) {
    return axios.post(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/booking-batches/window`,
      { ksef_invoice_ids: ids },
    );
  },

  // Szablony dla kontrahentów, których nie dało się rozstrzygnąć po NIP-ie — dociągane po
  // otwarciu okna, porcjami.
  bookingBatchWindowTemplates({ nips, evidenceKind }) {
    return axios.post(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/booking-batches/window/templates`,
      { nips, evidence_kind: evidenceKind },
    );
  },

  enqueueBookingBatch({ documents }) {
    return axios.post(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/booking-batches`,
      { documents },
    );
  },

  bookingBatchesStatus({ ids = [] } = {}) {
    return axios.get(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/booking-batches/status`,
      { params: { ksef_invoice_ids: ids } },
    );
  },

  verifyAdvanceInvoices({ id }) {
    return axios.get(
      `${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/${ id }/advance-invoice-verification`,
    );
  },
};
